/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef, type ForwardRefExoticComponent, type RefAttributes, type SVGProps} from 'react'

/**
 * @public
 */
export const ArrowTopRightIcon: ForwardRefExoticComponent<
  Omit<SVGProps<SVGSVGElement>, 'ref'> & RefAttributes<SVGSVGElement>
> = /* @__PURE__ */ forwardRef(function ArrowTopRightIcon(props, ref) {
  return (
    <svg
      data-sanity-icon="arrow-top-right"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path d="M16.5 8.5L7 18" stroke="currentColor" strokeWidth={1.2} strokeLinejoin="round" />
      <path d="M9 8.5H16.5V16" stroke="currentColor" strokeWidth={1.2} strokeLinejoin="round" />
    </svg>
  )
})

export {ArrowTopRightIcon as default}
